import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterMetadataComponent } from './letter-metadata.component';
import { LetterSimplifiedTargetTextModule } from '../letter-simplified-target-text/index';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  declarations: [LetterMetadataComponent],
  imports: [
    CommonModule,
    LetterSimplifiedTargetTextModule,
    TooltipModule.forRoot(),
  ],
  exports: [
    LetterMetadataComponent,
    CommonModule,
    LetterSimplifiedTargetTextModule,
    TooltipModule,
  ],
})
export class LetterMetadataModule { }
